export default function () {
  const noHover = window.matchMedia('(hover: none)').matches

  if (noHover) {
    document.body.classList.add('no-hover')
  }
}
